import _ from 'lodash';
import { adminClient as apolloClient } from '@/store/apollo';

import CurrenciesPaginatedGql from '@/extensions/shop/store/graphql/queries/CurrenciesPaginated.gql';
import SaveCurrencyGql from '@/extensions/shop/store/graphql/mutations/SaveCurrency.gql';
import DeleteCurrencyGql from '@/extensions/shop/store/graphql/mutations/DeleteCurrency.gql';

export default {
    fetchCurrenciesPaginated: (data) =>
        new Promise((resolve, reject) => {
            const filters = [];
            _.each(data.filters, (entry) => filters.push(entry));

            apolloClient
                .query({
                    query: CurrenciesPaginatedGql,
                    variables: {
                        scope: _.get(data, 'scope', 'ex'),
                        type: _.get(data, 'type', 'shop_currency'),
                        currentPage: _.get(data, 'pageInfo.currentPage', 1),
                        perPage: _.get(data, 'pageInfo.perPage', 25),
                        order: _.get(data, 'variables.order', ''),
                        direction: _.get(data, 'variables.direction', ''),
                        filters,
                    },
                    fetchPolicy: 'no-cache',
                })
                .then(({ data }) => resolve(data.CO_CurrenciesPaginated))
                .catch((err) => reject(err));
        }),
    fetchAllForShop: (cmsId = null) =>
        new Promise((resolve, reject) => {
            const filters = [];
            if (cmsId) {
                filters.push({
                    key: 'cms',
                    match: parseInt(cmsId),
                    like: '',
                    from: '',
                    to: '',
                    in: [],
                });
            }
            apolloClient
                .query({
                    query: CurrenciesPaginatedGql,
                    variables: {
                        scope: 'ex',
                        type: 'shop_currency',
                        currentPage: 1,
                        perPage: 1000,
                        order: 'iso4217',
                        direction: 'asc',
                        filters,
                    },
                    fetchPolicy: 'no-cache',
                })
                .then(({ data }) => resolve(_.get(data, 'CO_CurrenciesPaginated.items', [])))
                .catch((err) => reject(err));
        }),
    save: (currency, shopId = null) => {
        if (currency === undefined) throw new Error('required argument is missing');

        const payload = _.removeDeepByKey(_.cloneDeep(currency), '__typename');
        const variables = { currency: payload };
        if (shopId) variables.shop_id = parseInt(shopId);

        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: SaveCurrencyGql,
                    variables,
                })
                .then(async ({ data }) => {
                    await apolloClient.clearStore();
                    resolve(data.CO_SaveCurrency);
                })
                .catch((err) => reject(err));
        });
    },
    delete: (id) => {
        if (id === undefined) throw new Error('required argument is missing');

        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: DeleteCurrencyGql,
                    variables: { id: parseInt(id) },
                })
                .then(async ({ data }) => {
                    await apolloClient.clearStore();
                    resolve(data.CO_DeleteCurrency);
                })
                .catch((err) => reject(err));
        });
    },
};
